import Repository from "../Repository";

const Create = "createCourse";
const GetAll = "getAllCourse"
const GetSingle = "getSingleCourse";
const Delete = "deleteCourse"
const UPDATE_COURSE="edit"
export default {
 createCourse(payload) {
    return Repository.post(transformRoute(Create),payload);
  },
  getAllCourse(payload) {
    return Repository.post(transformRoute(GetAll),payload);
  },
  getSingleCourse(payload) {
    return Repository.post(transformRoute(GetSingle),payload);
  },
  deleteCourse(payload) {
    return Repository.post(transformRoute(Delete),payload);
  },
  updateCourse(payload) {
    return Repository.post(transformRoute(UPDATE_COURSE),payload);
  },
};

const transformRoute = (route) => {
  return `eLearning/elearningcourse/${route}`;
};
